import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';
import { ApiPayload } from '../../types/biddingPosts';
import {
  ContractItem,
  ContractBuyerDetailsPayload,
  IndustryTermsConditionItem,
} from '../../types/biddingContracts';

export const biddingContractsService = createApi({
  reducerPath: 'biddingContractsService',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['BiddingContracts', 'ContractDetails', 'IndustryTerms'],
  endpoints: (builder) => ({
    getContractsByPost: builder.query<ApiPayload<ContractItem[]>, { postId: string }>({
      query: ({ postId }) => ({
        url: `/supply-service/v1/operator/contracts/post/${postId}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { postId }) => [
        { type: 'BiddingContracts', id: postId },
      ],
    }),

    getContractDetails: builder.query<ApiPayload<ContractBuyerDetailsPayload>, { contractId: string }>({
      query: ({ contractId }) => ({
        url: `/supply-service/v1/operator/contracts/${contractId}/details`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { contractId }) => [
        { type: 'ContractDetails', id: contractId },
      ],
    }),

    getContractBuyerDetails: builder.query<ApiPayload<ContractBuyerDetailsPayload>, { contractId: string }>({
      query: ({ contractId }) => ({
        url: `/supply-service/v1/operator/contracts/${contractId}/buyer-details`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { contractId }) => [
        { type: 'ContractDetails', id: contractId },
      ],
    }),

    getProposalBuyerDetails: builder.query<ApiPayload<ContractBuyerDetailsPayload>, { proposalId: string }>({
      query: ({ proposalId }) => ({
        url: `/supply-service/v1/operator/contracts/proposal/${proposalId}/buyer-details`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { proposalId }) => [
        { type: 'ContractDetails', id: proposalId },
      ],
    }),

    getIndustryTermsCondition: builder.query<ApiPayload<IndustryTermsConditionItem[]>, { proposalId: string }>({
      query: ({ proposalId }) => ({
        url: `/supply-service/v1/operator/industry-terms-condiation/by-proposal/${proposalId}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { proposalId }) => [
        { type: 'IndustryTerms', id: proposalId },
      ],
    }),
  }),
});

export const {
  useGetContractsByPostQuery,
  useGetContractDetailsQuery,
  useGetContractBuyerDetailsQuery,
  useGetProposalBuyerDetailsQuery,
  useGetIndustryTermsConditionQuery,
} = biddingContractsService;
